import {
  Box,
  Chip,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'

const MaskingPDF = ({ recipe }) => {
  return (
    recipe.provided_input.indication === 'Veneer on refractory' && (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        flexGrow={1}
        p={5}
        sx={{ backgroundColor: '#FFF' }}
        id="download-page-0"
      >
        <Grid container spacing={2} sx={{ height: '100%' }}>
          <Grid item sm={4}>
            <Box
              sx={{
                backgroundColor: '#FFF',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={ToothGraphic5}
                alt="Toothimage"
                style={{ width: 233, height: 330 }}
              />
            </Box>
          </Grid>

          <Grid
            item
            sm={8}
            display="flex"
            flexDirection="column"
            sx={{ color: 'black' }}
          >
            {/* Masking */}
            <Box display="flex" alignItems="center" m={3}>
              <Typography variant="h5" sx={{ marginRight: 2 }}>
                Masking:
              </Typography>
              <Chip
                label={`${recipe.internallayer_advice.capbrand} ${recipe.provided_input.brand}`}
                sx={{
                  backgroundColor: '#F44336',
                  color: '#FFF',
                  borderRadius: '16px',
                }}
              />
            </Box>

            {/* Table */}
            <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                      Cervical
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                      Middle
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                      Incisal
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[
                    [
                      'Instructions',
                      'instructions_cervical',
                      'instructions_middle',
                      'instructions_incisal',
                    ],
                    [
                      'Ceramic type',
                      'ceramictype_cervical',
                      'ceramictype_middle',
                      'ceramictype_incisal',
                    ],
                    [
                      'Thickness',
                      'thickness_cervical',
                      'thickness_middle',
                      'thickness_incisal',
                    ],
                    [
                      'Staining instructions',
                      'staining_instructions_cervical',
                      'staining_instructions_middle',
                      'staining_instructions_incisal',
                    ],
                  ].map(([label, cervical, middle, incisal]) => (
                    <TableRow key={label}>
                      <TableCell sx={{ fontWeight: 'bold' }}>{label}</TableCell>
                      <TableCell align="center">
                        {recipe.internallayer_advice[cervical] || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {recipe.internallayer_advice[middle] || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {recipe.internallayer_advice[incisal] || '-'}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Conditional Rows */}
                  {(recipe.internallayer_advice.instructions_cervical?.[0] !==
                    'Masking recipe is not required.' ||
                    recipe.internallayer_advice.instructions_middle?.[0] !==
                      'Masking recipe is not required.' ||
                    recipe.internallayer_advice.instructions_incisal?.[0] !==
                      'Masking recipe is not required.') && (
                    <>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Estimated required staining
                        </TableCell>
                        {[
                          'stainingdelLAB_cervical',
                          'stainingdelLAB_middle',
                          'stainingdelLAB_incisal',
                        ].map((key) => (
                          <TableCell align="center" key={key}>
                            {recipe.internallayer_advice[key]?.[1]
                              ? `∆A ${recipe.internallayer_advice[key][1].toFixed(2)}`
                              : '-'}
                            {recipe.internallayer_advice[key]?.[2]
                              ? ` ∆B ${recipe.internallayer_advice[key][2].toFixed(2)}`
                              : '-'}
                          </TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Estimated required staining in VITA3D
                        </TableCell>
                        {[
                          'VITAafterstaining_cervical',
                          'VITAafterstaining_middle',
                          'VITAafterstaining_incisal',
                        ].map((key) => (
                          <TableCell align="center" key={key}>
                            {recipe.internallayer_advice[key] || '-'}
                          </TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Staining brand
                        </TableCell>
                        {[
                          'stain_cervical',
                          'stain_middle',
                          'stain_incisal',
                        ].map((key) => (
                          <TableCell align="center" key={key}>
                            {recipe.internallayer_advice[key] || '-'}
                          </TableCell>
                        ))}
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* Divider */}
        <Box
          sx={{
            height: '1px',
            backgroundColor: 'black',
            opacity: 1,
            mt: 2,
          }}
        />
      </Box>
    )
  )
}

export default MaskingPDF
